import { useContext } from 'react';
import { ThemeContext, type ThemeContextValue } from './theme-context';

/**
 * useTheme - read the current theme and trigger theme changes.
 *
 * Throws if used outside a ThemeProvider. Treat that as a programming
 * error rather than a recoverable runtime condition.
 */
export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return ctx;
}
